import React, { Component } from 'react';
import {
    Select,
    Input,
    Button,
    Radio,
} from 'antd';
import { Form } from '@ant-design/compatible';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Erase } from '@carbon/icons-react';
import * as eventsActions from '../../../core/events/eventsActions';
import * as assetActions from '../../../core/asset/assetActions';
import * as deviceActions from '../../../core/device/deviceActions';

class TriggersFilterForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            division_or_asset: 'divisions'
        }
    }

    componentDidMount() {
        const { actions } = this.props;

        actions.getUserDivisionsRequest();
        actions.getCompanyAllTriggersRequest();
    }

    submitForm = (e) => {
        e.preventDefault();
        const { onSubmit } = this.props;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                onSubmit(values);
            }
        });
    };

    render() {
        const { form, divisions, assetOptions, allTriggers } = this.props;
        const { division_or_asset } = this.state;
        const { getFieldDecorator } = form;
        return (
            <Form onSubmit={this.submitForm} layout="vertical">
                <Form.Item label="Geo-fence name">
                    {getFieldDecorator('geofence_name', {})(
                        <Select
                            showSearch
                            allowClear={<Erase size={12} />}
                            filterOption={(txt, obj) => (obj.props.children.toLowerCase().includes(txt.toLowerCase()))}
                            placeholder="Select Geofence"
                        >
                            {allTriggers.map((trigger) => (
                                <Select.Option
                                    key={trigger.name}
                                    value={trigger.name}
                                >
                                    {trigger.name}
                                </Select.Option>
                            ))}
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label="Report Type" style={{ textTransform: 'none' }}>
                    {getFieldDecorator('division_or_asset', {
                        initialValue: 'divisions',
                    })(
                        <Radio.Group onChange={(e) => this.setState({ division_or_asset: e.target.value })}>
                            <Radio value="divisions">Divisions</Radio><br />
                            <Radio value="assets">Assets</Radio>
                        </Radio.Group>
                    )}
                </Form.Item>
                {division_or_asset === 'divisions' ? (
                    <Form.Item label="Divisions">
                        {getFieldDecorator('geofence_division', {})(
                        <Select
                            placeholder="Select Division"
                            allowClear={<Erase size={12} />}
                            showSearch
                        >
                                <Select.Option value={''}>All</Select.Option>
                                {divisions.map((division, divisionIndex) => <Select.Option key={divisionIndex} value={division.id}>{division.name}</Select.Option>)}
                            </Select>
                    )}
                </Form.Item>
                ) : null}
                {division_or_asset === 'assets' ? (
                    <Form.Item label="Asset">
                        {getFieldDecorator('geofence_assets', {})(
                        <Select
                            showSearch
                            mode="multiple"
                            allowClear={<Erase size={12} />}
                            filterOption={(txt, obj) => (obj.props.children.toLowerCase().includes(txt.toLowerCase()))}
                            placeholder="Select Asset"
                        >
                                {assetOptions.map((a) => (
                                    <Select.Option key={a.id} value={a.id}>
                                        {a.name === a.reg || a.reg === '' ? a.name : `${a.name} [${a.reg}]`}
                                    </Select.Option>
                                ))}
                            </Select>
                    )}
                </Form.Item>
                ) : null}


                <div className="mt-2 mb-1 text-center">
                    <Button
                        htmlType="submit"
                        type="primary"
                    >
                        Filter
                    </Button>
                </div>
            </Form>
        );
    }
}

const TriggersFilter = Form.create({ name: 'event_filter_form' })(TriggersFilterForm);

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        divisions: state.events.divisions,
        assetOptions: state.asset.options,
        allTriggers: state.device.allTriggers,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...eventsActions,
            ...assetActions,
            ...deviceActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TriggersFilter);
